import { SingleDataValue } from './SingleDataValue';

const newSectionHeight = (section, data, contents) => {
    let sectionHeight = singleSectionHeight(section, data);
    const singleHeight = sectionHeight;
    let sectionFound = false;

    if (section.LinkedSections) {
        let count = Math.min(section.LinkedSections, 3);
        for (const row of contents) {
            if (sectionFound && count > 0) {
                const oldHeight = sectionHeight;
                sectionHeight += singleSectionHeight(row, data);
                count -= oldHeight !== sectionHeight ? 1 : 0;
            }
            if (row.Name === section.Name) {
                sectionFound = true;
            }
        }
    }

    return { singleHeight: singleHeight, combinedHeight: sectionHeight };
};

const singleSectionHeight = (section, data) => {
    let lines = 0;
    const sectionType = section.Type.toLowerCase();

    if (
        sectionType !== 'table' &&
        sectionType !== 'reportimage' &&
        !doesSingleFieldContainData(section, data)
    ) {
        return 0;
    }

    //TODO: Need to check section for images, loop through image.x + image.height and find the max

    switch (sectionType) {
        case 'absolute':
            //TODO: calculate the height of the lines from the lines property, this needs to take into account font size
            break;
        case 'singlefieldcolumn':
            lines = section.Column1.Fields.length;
            break;
        case ('singlefieldcolumnwithrowheading',
        'singlefieldcolumnwithseparateheading'):
            lines = section.Column1.Fields.length;
            break;
        case 'dynamicsinglecolumnone':
            if (section.Column1.Fields.length > 1) {
                lines = section.Column1.Fields.length - 0.6;
            }
            break;
        case 'doublefieldcolumn':
            const lineOne = section.Column1.Fields.length;
            const lineTwo = section.Column2.Fields.length;
            lines = Math.max(lineOne, lineTwo);
            break;
        case 'doublefieldcolumnwithrowheading':
            const lOne = section.Column1.Fields.length;
            const lTwo = section.Column2.Fields.length;
            lines = Math.max(lOne, lTwo);
            break;
        case 'table':
            if (data.Tables && data.Tables.length > 0) {
                const tableData = data.Tables.find(
                    (f) => f.Key.toLowerCase() === section.Data.toLowerCase()
                );
                if (tableData) {
                    lines = tableData.Rows.length;
                    lines += Array.isArray(section.Head) ? 1.4 : 0.2;
                }
            }
            break;
        case 'reportimage':
            for (const field of section.Column1.Fields) {
                if (field.Image) {
                    return field.Height;
                }
            }
            break;
        default:
            break;
    }

    if (section.Heading && section.Heading[0].Text) {
        lines += 1;
    }

    // TODO: need to decide what to return - line*23 or max image height if greater
    return lines * 23;
};

const normalLinesHeight = (lines, data) => {
    let lineNumber = lines[lines.length - 1].Line; //TODO: this isn't going to work if the line numbers are out of order in the json
    return lineNumber * 16;
};

const doesSingleFieldContainData = (section, data) =>
    section?.Column1?.Fields.some(
        (row) => SingleDataValue(row.Value, data) !== ''
    );

export { normalLinesHeight as NormalLinesHeight, newSectionHeight as NewSectionHeight };
